import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import parentStyles from '../styles.module.scss'
import { CartesianGrid, LabelList, Line, LineChart, ResponsiveContainer, XAxis, YAxis } from 'recharts'
import { getDateFormatRange1 } from 'srcReact/helpers/datetimeHelper'
import { useTranslation } from 'react-i18next'
import Variant from 'srcReact/Dashboard/components/common/Variant'

function NewMemberGraph({ graphData }) {
  const { t } = useTranslation()
  const [data, setData] = useState([])

  useEffect(() => {
    if (graphData?.length > 0) {
      setData([
        {
          name: getDateFormatRange1(graphData[3].period_start_at, graphData[3].period_end_at),
          uv: parseInt(graphData[3].value),
          variant: parseInt(graphData[3].value)
        },
        {
          name: getDateFormatRange1(graphData[2].period_start_at, graphData[2].period_end_at),
          uv: parseInt(graphData[2].value),
          variant: parseInt(graphData[2].value)
        },
        {
          name: getDateFormatRange1(graphData[1].period_start_at, graphData[1].period_end_at),
          uv: parseInt(graphData[1].value),
          variant: parseInt(graphData[1].value)
        },
        {
          name: getDateFormatRange1(graphData[0].period_start_at, graphData[0].period_end_at),
          uv: parseInt(graphData[0].value),
          variant: parseInt(graphData[0].value)
        }
      ])
    }
  }, [graphData])

  return (
    <div className={`${parentStyles.graph} ${styles.graph}`}>
      <ResponsiveContainer>
        <LineChart data={data} isAnimationActive={false} margin={{ left: 10, right: 10 }}>
          <CartesianGrid strokeArray='5' strokeWidth={2} stroke='#d4d4e0' vertical={false} />
          <XAxis
            dataKey='name'
            strokeWidth={3}
            stroke={'#28363d'}
            interval={0}
            tick={{ fontSize: 10, fill: '#28363d' }}
            dy={10}
          />
          <YAxis domain={['dataMin - 2', 'dataMax + 4']} interval={0} hide={true} />
          <Line
            type='monotone'
            dataKey='uv'
            stroke='#82ca9d'
            strokeWidth={3}
            dot={{ stroke: '#feb200', strokeWidth: 3 }}>
            <LabelList
              dataKey='variant'
              position='top'
              offset={10}
              style={{ fontSize: '14px', fontWeight: 'bold', fill: '#fcb116' }}
            />
          </Line>
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}

export default NewMemberGraph
